<template>
  <div id="wrapper" class="noheader" v-if="!onSetting">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>推播項目</p>
          <span></span>
        </div>
        <a class="arr" @click.prevent="$router.replace('/MemberShip')"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="notificationBtn" @click="openSetting">
        <a class="btn">相關設定</a>
      </div>
      <div class="notificationBox">
        <div class="box">
          <div class="type"><p>公告</p></div>
          <div class="data">
            <div class="title"><p>產兆及生產方式</p></div>
            <div class="txt">
              <p>
                活動時間&nbsp;:&nbsp;2020-09-08&nbsp;&nbsp;PM04:00<br />活動地點&nbsp;:&nbsp;木生媽媽教室
              </p>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="type"><p>公告</p></div>
          <div class="data">
            <div class="title"><p>自然生產還是剖腹產</p></div>
            <div class="txt">
              <p>
                活動時間&nbsp;:&nbsp;2020-09-08&nbsp;&nbsp;PM04:00<br />活動地點&nbsp;:&nbsp;木生媽媽教室
              </p>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="type"><p>公告</p></div>
          <div class="data">
            <div class="title"><p>High&nbsp;Q營養與探索</p></div>
            <div class="txt">
              <p>
                活動時間&nbsp;:&nbsp;2020-09-08&nbsp;&nbsp;PM04:00<br />活動地點&nbsp;:&nbsp;木生媽媽教室
              </p>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="type"><p>公告</p></div>
          <div class="data">
            <div class="title"><p>新手父母常見的寶寶照護問題</p></div>
            <div class="txt">
              <p>
                活動時間&nbsp;:&nbsp;2020-09-08&nbsp;&nbsp;PM04:00<br />活動地點&nbsp;:&nbsp;木生媽媽教室
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="noheader" v-else id="wrapper">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>推播設定</p>
          <span></span>
        </div>
        <a class="arr" @click="onSetting = false"><div class="inner"></div></a>
      </div>
      <div class="notificationSettingBox">
        <div class="box">
          <div class="txt">掛號完成提醒</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('掛號完成提醒')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle1"
                  v-model="info.掛號完成提醒"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle1" v-if="!info.掛號完成提醒">開啟</label>
              <label for="toggle1" v-else>關閉</label>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="txt">就診前提醒</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('就診前提醒')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle2"
                  v-model="info.就診前提醒"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle2" v-if="!info.就診前提醒">開啟</label>
              <label for="toggle2" v-else>關閉</label>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="txt">候診提醒</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('候診提醒')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle3"
                  v-model="info.候診提醒"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle3" v-if="!info.候診提醒">開啟</label>
              <label for="toggle3" v-else>關閉</label>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="txt">衛教通知</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('衛教通知')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle4"
                  v-model="info.衛教通知"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle4" v-if="!info.衛教通知">開啟</label>
              <label for="toggle4" v-else>關閉</label>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="txt">關懷提醒</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('關懷提醒')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle5"
                  v-model="info.關懷提醒"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle5" v-if="!info.關懷提醒">開啟</label>
              <label for="toggle5" v-else>關閉</label>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="txt">最新消息</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('最新消息')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle6"
                  v-model="info.最新消息"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle6" v-if="!info.最新消息">開啟</label>
              <label for="toggle6" v-else>關閉</label>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="txt">客戶滿意度調查推播通知</div>
          <div class="btn">
            <div class="toggleBtnBox" @click="change('客戶滿意度調查推播通知')">
              <div class="toggleMC">
                <input
                  type="checkbox"
                  class="checkbox_toggleType"
                  id="toggle7"
                  v-model="info.客戶滿意度調查推播通知"
                />
                <span class="checkbox_round"></span>
              </div>
              <label for="toggle7" v-if="!info.客戶滿意度調查推播通知"
                >開啟</label
              >
              <label for="toggle7" v-else>關閉</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }} </template>
  </modal>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      modal: {},
      info: {},
      onSetting: false
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  mounted: function() {
    api.notification
      .query({
        jwt: this.member.jwt
      })
      .then(data => {
        console.log(data);
        this.info = data.notifications;
      })
      .catch(error => {
        this.modal = {
          display: true,
          header: "網路連線異常",
          body: error.message
        };
      });
  },
  methods: {
    openSetting() {
      if (this.member.info.verified !== 1) {
        this.modal = {
          display: true,
          header: "提醒訊息",
          body: "請先申請帳號並完成驗證後方能設定推播。"
        };
        return false;
      }
      this.onSetting = true;
    },
    change(which) {
      // 直接更新
      this.info[which] = !this.info[which];
      console.log(this.info);
      api.notification
        .updateOne({
          jwt: this.member.jwt,
          notifications: this.info
        })
        .then(data => {
          console.log(data);
        })
        .catch(error => {
          this.modal = {
            display: true,
            header: "網路連線異常",
            body: error.message
          };
        });
    }
  }
};
</script>
